import {
    Box,
    Button,
    CardContent,
    CardHeader,
    Container,
    Grid,
    IconButton,
    Tooltip,
    Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { StyledCard } from "../StepMainEdit";
import {
    VendorCardTitle,
    VendorListHolder,
} from "./vendorReg";
import BankDetailsContent1 from "../../../bankDetails/components/bankDetailsContent1";
import { getBanks } from "../../../bankDetails/redux/bankDetailsSlice";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { LeftDetailsBankCard, RightDetailsBankCard } from "../../../bankDetails/components/bankAccountsContent";
import LoadingButton from "@mui/lab/LoadingButton";
import { message } from "antd";
import { submitVendorEdit } from "../../redux/vendorRegistrationSlice";
import { history } from "../../../../app/history";
import LocalStorage from "../../../../utilities/localStorage";

const BankCard = ({ item, is_domestic, onEdit, isLocked }) => {
    const bankData = item?.item || item;
    const {
        id,
        bank_name,
        city,
        branch_name,
        account_name,
        account_number,
        is_primary_account,
        currency,
    } = bankData;

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <StyledCard sx={{ border: "1px solid #EAEAEF", mb: 2 }}>
            <CardHeader
                action={
                    !isLocked && (
                        <IconButton aria-label="settings" onClick={handleClick}>
                            <MoreVertIcon />
                        </IconButton>
                    )
                }
                title={
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Typography variant="h6" sx={{ fontWeight: 600, fontSize: '16px' }}>
                            {bank_name}
                        </Typography>
                        {is_primary_account ? (
                            <Box
                                sx={{
                                    fontSize: "12px",
                                    borderRadius: "15px",
                                    background: "#D55EE1",
                                    padding: "2px 12px",
                                    color: "white",
                                    ml: 1,
                                }}
                            >
                                Primary
                            </Box>
                        ) : null}
                    </Box>
                }
            />
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            >
                {!isLocked && <MenuItem onClick={() => { handleClose(); onEdit(id); }}>Edit</MenuItem>}
            </Menu>
            <CardContent>
                <Grid container spacing={1}>
                    <Grid item xs={6}><LeftDetailsBankCard>City:</LeftDetailsBankCard></Grid>
                    <Grid item xs={6} sx={{ textAlign: 'right' }}><RightDetailsBankCard>{city}</RightDetailsBankCard></Grid>
                    <Grid item xs={6}><LeftDetailsBankCard>Branch:</LeftDetailsBankCard></Grid>
                    <Grid item xs={6} sx={{ textAlign: 'right' }}><RightDetailsBankCard>{branch_name}</RightDetailsBankCard></Grid>
                    <Grid item xs={6}><LeftDetailsBankCard>A/C name:</LeftDetailsBankCard></Grid>
                    <Grid item xs={6} sx={{ textAlign: 'right' }}><RightDetailsBankCard>{account_name}</RightDetailsBankCard></Grid>
                    <Grid item xs={6}><LeftDetailsBankCard>{is_domestic ? "A/C number:" : "IBAN Number"}</LeftDetailsBankCard></Grid>
                    <Grid item xs={6} sx={{ textAlign: 'right' }}><RightDetailsBankCard>{account_number}</RightDetailsBankCard></Grid>
                </Grid>
            </CardContent>
        </StyledCard>
    );
};

export default function BankDetailsManager({
    vendor_id,
    user_id,
    handleBack,
    activeStep,
    is_domestic,
    company_id,
    setSkipped,
    setActiveStep,
    isStepSkipped,
    skipped,
    isLocked,
    isCreation = false,
}) {
    const dispatch = useDispatch();
    const loginUserDetails = LocalStorage.getItem("tata_login_user");
    const { banks, loading } = useSelector((state) => state.bankdetails);
    const [view, setView] = useState("list"); // list, add, edit
    const [editingBankId, setEditingBankId] = useState(null);
    const [hasPendingChanges, setHasPendingChanges] = useState(false);
    const [isFinishing, setIsFinishing] = useState(false);
    const isOfficer = loginUserDetails.roles.includes("officer");
    const client = LocalStorage.getItem("client");
    const isTenant2 = client?.id === 2;
    console.log("isLocked", banks)
    useEffect(() => {
        if (vendor_id || user_id) {
            dispatch(getBanks(vendor_id || user_id));
        }
    }, [dispatch, vendor_id, user_id]);

    const handleAdd = () => {
        setView("add");
    };

    const handleEdit = (id) => {
        setEditingBankId(id);
        setView("edit");
    };

    const handleCancel = () => {
        setView("list");
        setEditingBankId(null);
    };

    const handleSuccess = () => {
        setView("list");
        setEditingBankId(null);
        console.log("vendor_id: ", vendor_id || user_id);
        dispatch(getBanks(vendor_id || user_id));
        setHasPendingChanges(true);
    };

    const handleFinish = () => {
        const user = LocalStorage.getItem("tata_login_user");
        const primary_role = user.roles[0];

        if (!vendor_id) {
            message.error("Vendor ID is missing. Please refresh the page and try again.");
            return;
        }

        if (!hasPendingChanges && (!banks || banks.length === 0)) {
            message.info("Please add or edit a bank account before finishing.");
            return;
        }

        // In creation mode, the bank is already saved — just navigate to /app.
        // submitVendorEdit is only for submitting pending edits on an existing vendor.
        if (isCreation) {
            message.success("Registration completed successfully!");
            history.push("/app");
            return;
        }

        const payload = {
            vendor_id: vendor_id,
            is_finish: isTenant2 ? true : false
        };

        setIsFinishing(true);
        dispatch(submitVendorEdit(payload))
            .unwrap()
            .then((res) => {
                setIsFinishing(false);
                if (res?.success) {
                    message.success(res?.message || "Edits submitted successfully.");
                } else {
                    message.info(res?.message || "No pending edits to submit.");
                }
                if (primary_role === "user") {
                    history.push("/app");
                } else {
                    let newSkipped = skipped;
                    if (isStepSkipped(activeStep)) {
                        newSkipped = new Set(newSkipped.values());
                        newSkipped.delete(activeStep);
                    }
                    setActiveStep((prevActiveStep) => prevActiveStep + 1);
                    setSkipped(newSkipped);
                }
            })
            .catch((err) => {
                setIsFinishing(false);
                message.error("Failed to submit edits.");
            });
    };

    if (view === "add" || view === "edit") {
        return (
            <BankDetailsContent1
                vendor_id={vendor_id}
                createdUser={{ id: user_id }}
                is_domestic={is_domestic}
                company_id={company_id}
                bankInfoId={editingBankId}
                isVendorEditStepper={true}
                onSuccess={handleSuccess}
                onCancel={handleCancel}
                isLocked={isLocked}
            />
        );
    }

    return (
        <Box>
            <StyledCard>
                <CardContent>
                    <VendorCardTitle>{isOfficer ? "Step 4" : "Step 3"}: Bank Details</VendorCardTitle>
                    <VendorListHolder>
                        <li>Manage your bank account here. {isTenant2 ? "Only one bank account is allowed." : ""}</li>
                        <li>Ensure the account is marked as Primary.</li>
                    </VendorListHolder>
                </CardContent>
            </StyledCard>

            <Grid container spacing={2}>
                {banks && banks.length > 0 ? (
                    banks.map((bank) => (
                        <Grid item xs={12} md={6} key={bank.id}>
                            <BankCard item={bank} is_domestic={is_domestic} onEdit={handleEdit} isLocked={isLocked} />
                        </Grid>
                    ))
                ) : (
                    <Grid item xs={12}>
                        <Typography sx={{ textAlign: 'center', my: 4, color: '#666687' }}>
                            No bank accounts added yet.
                        </Typography>
                    </Grid>
                )}
            </Grid>

            {(!banks || banks.length === 0) && !isLocked && (
                <Box sx={{ textAlign: 'center', my: 2 }}>
                    <Button
                        variant="outlined"
                        onClick={handleAdd}
                        sx={{ textTransform: 'none', borderStyle: 'dashed' }}
                    >
                        + Add Bank Account
                    </Button>
                </Box>
            )}

            <Box sx={{ display: "flex", flexDirection: "row", pt: 2, justifyContent: "space-between" }}>
                <Button color="inherit" onClick={handleBack} sx={{ mr: 1 }}>Back</Button>
                <Tooltip
                    title={(!banks || banks.length === 0) ? "Please add at least one bank account to continue" : ""}
                    arrow
                    placement="top"
                >
                    <span>
                        <LoadingButton
                            sx={{ textTransform: "none", background: "var(--button-color)", width: "200px" }}
                            color="success"
                            variant="contained"
                            onClick={handleFinish}
                            disabled={(!banks || banks.length === 0) || isLocked}
                            loading={isFinishing}
                        >
                            {isLocked ? "Submitted" : "Finish"}
                        </LoadingButton>
                    </span>
                </Tooltip>
            </Box>
        </Box>
    );
}
